///////////////////////////////////////////////////////
// Outline
///////////////////////////////////////////////////////
/*
    1. Interface
        a. init
        b. getTypeName
    
    2. Helpers
        a. ensureGoogleMapApi 
        b. geocode 
        c. setMap

    3. Property Accessors
        a. getData
*/

(function () {
    'use strict';

    angular
        .module('app.courseHandicap')
        .component('sc3FacilityPanel', {
            templateUrl: 'app/course-handicap/facility-panel.component.html',
            controller: FacilityPanelComponent,
            bindings: { model: '<' }
        });

    var noop = angular.noop,
        copy = angular.copy;

    FacilityPanelComponent.$inject = ['$q', '$scope', 'uiGmapGoogleMapApi', 'defaultCourseLogoUrl', 'courseContactType'];
    function FacilityPanelComponent($q, $scope, uiGmapGoogleMapApi, defaultCourseLogoUrl, courseContactType) {
        // Variables
        var ctrl = this,
            Geocoder, GeocoderStatus, Marker;

        // Properties
        ctrl.map = null;
        ctrl.golfProLimit = 2;
        ctrl.defaultCourseLogo = defaultCourseLogoUrl;
        Object.defineProperty(ctrl, 'data', { get: getData });

        // Methods
        ctrl.$onInit = init;

        ///////////////////////////////////////////////////////
        // Interface
        ///////////////////////////////////////////////////////
        function init() {
            $scope.$watch('$ctrl.data.facility', facilityWatchAction);
            
            function facilityWatchAction(newVal, oldVal) {
                setMap().catch(noop);
            }
        }

        ///////////////////////////////////////////////////////
        // Helpers
        ///////////////////////////////////////////////////////
        function ensureGoogleMapApi() {
            return uiGmapGoogleMapApi.then(setClasses);

            function setClasses(maps) {
                if (!Geocoder) {
                    Geocoder = maps.Geocoder;
                    GeocoderStatus = maps.GeocoderStatus;
                    Marker = maps.Marker;
                }
                return maps;
            }
        }
        function geocode(address) {
            return address ? ensureGoogleMapApi().then(geocode) : $q.reject('No Address');

            function geocode() {
                var geocoder = new Geocoder(),
                    deferred = $q.defer();

                geocoder.geocode({ 'address': address }, callback);
                return deferred.promise;

                function callback(results, status) {
                    status === GeocoderStatus.OK ? deferred.resolve(results) : deferred.reject(status);
                }
            }
        }
        function setMap() {
            return ensureGoogleMapApi()
                .then(getAddress)
                .then(getCoordinates)
                .then(setMap)
                .catch(clearMap);

            function getAddress() {
                var data = ctrl.data,
                    facility = data && data.facility,
                    hasValidAddress = facility && facility.address1 && facility.city && facility.region && facility.postalCode;

                return hasValidAddress ? facility.address1 + '\n' + facility.city + ', ' + facility.region + ' ' + facility.postalCode : null;
            }

            function getCoordinates(address) {
                return geocode(address);
            }

            function setMap(results) {
                var location = results[0].geometry.location,
                    center = { latitude: location.lat(), longitude: location.lng() },
                    markerCoords = copy(center);

                ctrl.map = { center: center, markerCoords: markerCoords };
            }

            function clearMap(rejection) {
                ctrl.map = null;
            }
        }

        ///////////////////////////////////////////////////////
        // Property Accessors
        ///////////////////////////////////////////////////////
        function getData() {
            return ctrl.model.data;
        }
    }
})();